import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import Pencil from '~/components/icons/Pencil.tsx';
import { ClarifyingInfoModal } from './ClarifyingInfoModal.tsx';
import { useFormContext } from 'react-hook-form';
import { TPurposeOfBusinessRelations } from '../../../types.ts';
import { errorMessages } from '~/constants/errorMessages.js';
import { commonStyles } from '~/theme/styles/commonStyles.ts';

export const ClarifyingInformation = () => {
  const [isOpened, setIsOpened] = useState(false);
  const {
    formState: { errors },
  } = useFormContext<TPurposeOfBusinessRelations>();
  const hasError = !!errors.explanation;

  const handleModalClose = () => {
    setIsOpened(false);
  };

  return (
    <>
      <Box data-name="explanation" sx={{ width: '100%' }}>
        <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
          <Typography variant="body1" onClick={() => setIsOpened(true)} sx={{ cursor: 'pointer' }}>
            Надайте уточнюючу інформацію щодо зміста та суті діяльності
          </Typography>

          <Pencil isError={hasError} onClick={() => setIsOpened(true)} />
        </Box>

        {hasError && (
          <Typography variant="caption" sx={{ color: 'error.main', display: 'block' }}>
            {errors.explanation?.message ?? errorMessages.FILL_CLARIFYING_INFORMATION}
          </Typography>
        )}
      </Box>

      <ClarifyingInfoModal isOpened={isOpened} handleClose={handleModalClose} />
    </>
  );
};
